import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as queryString from 'qs';
import { Observable } from 'rxjs';
import { PosMachineParams, PosMachineDatatable, PosMachine } from './pos-machine.model';

@Injectable({
  providedIn: 'root',
})
export class PosMachineService {
  api = '/pos_machines';

  constructor(private http$: HttpClient) {}

  getList(params?: PosMachineParams): Observable<PosMachineDatatable> {
    return this.http$.get<PosMachineDatatable>(`${this.api}?datatable=true&${queryString.stringify(params)}`);
  }

  gets(params = {}): Observable<PosMachine> {
    return this.http$.get<PosMachine>(this.api, { params });
  }

  find(id: number): Observable<PosMachine> {
    return this.http$.get<PosMachine>(`${this.api}/${id}`);
  }

  create(paylaod: PosMachine): Observable<PosMachine> {
    return this.http$.post<PosMachine>(`${this.api}`, paylaod);
  }

  update(paylaod: { id: number; data: PosMachine }): Observable<PosMachine> {
    return this.http$.put<PosMachine>(`${this.api}/${paylaod.id}`, paylaod.data);
  }

  delete(id: number) {
    return this.http$.delete<PosMachine>(`${this.api}/${id}`);
  }
}
